<footer class="footer" directive-draw-min-height="register">
    <div class="footer__wrapper wrapper">
        <div class="footer__row row">
            <div class="footer__col col -left">
                <shared-powered-by></shared-powered-by>
                <div class="footer__version" *ngIf="version">
                    v{{version}}
                </div>
            </div>

            <div class="footer__col col -right">
                <ul class="footer__list">
                    <li class="footer__li" *ngFor="let link of links$ | async">
                        <a (click)="handleLinkClick($event, link)" [href]="link.url" class="footer__link"
                            [title]="link.name">{{link.name}}</a>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</footer>